// Placeholder component - redirect logic is now in /open.html
export function InAppBrowserDetector(): null {
  return null;
}
